module.exports = __webpack_public_path__ + "static/media/welcome_banner.82347494.jpeg";